// extracted by mini-css-extract-plugin
export var li = "_ut-2";
export var ol = "_ut-1";
export var ul = "_ut-0";